import { plainToInstance, Type } from 'class-transformer'
import { IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Max, Min } from 'class-validator'

export class SaveForecastDay {
  public static build(raw: any) {
    return plainToInstance(SaveForecastDay, raw)
  }

  @IsNumber()
  @IsOptional()
  id?: number

  @IsNumber()
  @IsNotEmpty()
  @Min(0)
  @Max(255)
  numberOfDays: number | undefined

  @IsNumber()
  @IsNotEmpty()
  regionId: number | undefined
}

export class SaveCroptypePlanning {
  public static build(raw: any) {
    return plainToInstance(SaveCroptypePlanning, raw)
  }

  @IsNumber()
  @IsOptional()
  id?: number

  @IsNumber()
  @IsNotEmpty()
  @Min(0)
  @Max(255)
  cadenceTh: number | undefined

  @IsNumber()
  @IsNotEmpty()
  @Min(0)
  @Max(255)
  limitBeforeHarvest: number | undefined

  @IsNumber()
  @IsNotEmpty()
  timeArrivedSite: number | undefined

  @IsNumber()
  @IsNotEmpty()
  timeWaitFactory: number | undefined

  @IsString()
  @IsOptional()
  vegetableType?: string

  @IsNumber()
  @IsNotEmpty()
  regionId: number | undefined

  @IsNumber()
  @IsNotEmpty()
  croptypeId: number | undefined

  @IsNumber()
  @IsNotEmpty()
  @IsInt()
  aggregationTime!: number

  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(10)
  @IsOptional()
  zoomLevel?: number = 1
}

export class SaveFactoryConsumption {
  public static build(raw: any) {
    return plainToInstance(SaveFactoryConsumption, raw)
  }

  @IsNumber()
  @IsOptional()
  id?: number

  @IsString()
  @IsNotEmpty()
  startingHour: string | undefined

  @IsNumber()
  @IsNotEmpty()
  regionId: number | undefined
}
